import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import PinSetForm from '../../components/pin/PinSetForm';
import Storage from '../../services/Storage';

export default function SetPin() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])

  return (
    <PinSetForm />
  );
}